<div class="form-group">
  <label>{{getLabel()}}</label>
  <simplemde class="simplemde" [formControl]="fieldControl" [ngClass]="getValidityClass()"></simplemde>
  <div *ngIf="hasFieldErrors()" class="invalid-feedback">{{getErrorMessage()}}</div>
</div>
